export default "__VITE_ASSET__4633d4a2__"